<div class="thumbnail-container">
  @if (loadedImage) {
    <div
      #canvas
      class="canvas fs-block fs-exclude no-edit"
      [ngStyle]="imageStyles"
      (click)="onImageClick()"
      >
      @if (boxes?.length > 0) {
        <span class="footnote-count-badge">{{ boxes.length }}</span>
      }
      @for (box of boxes; track box; let idx = $index) {
        <div
          class="box"
                [ngStyle]="{
            'width': (box.x2 * (imageWidth / box.pageWidth)) - (box.x1 * (imageWidth / box.pageWidth)) + 'px',
            'height': (box.y2 * (imageHeight / box.pageHeight)) - (box.y1 * (imageHeight / box.pageHeight)) + 'px',
            'top': (box.y1 * (imageHeight / box.pageHeight)) + 'px',
            'left': (box.x1 * (imageWidth / box.pageWidth)) + 'px'
        }"
                [ngClass]="{
          'active': box.active,
          'selected': box.selected
        }"
          >
        </div>
      }
    </div>
    <div class="page-number" [class.centered]="hidePagePrefix">{{ hidePagePrefix ? '' : 'Page ' }}{{ !isNaN(page?.pageIndex) ? page.pageIndex + 1 : '--' }}</div>
  } @else {
    <div class="image-placeholder">
      @if (!imageFailedToLoad) {
        <div class="loader"></div>
      } @else {
        <i class="fa fa-circle-exclamation"></i>
      }
    </div>
  }
</div>
